import $ from 'jquery';
import Swal from 'sweetalert2';

export function initTiangNativeTable() {
    const table = document.getElementById('tableTiang');
    if (!table || !table.classList.contains('tiang-native-table')) return;

    console.log('[TiangNative] Initializing native JS data table');

    const ajaxUrl = table.dataset.ajaxUrl;
    const tableBody = document.getElementById('nativeTableBody');
    const lengthMenu = document.getElementById('nativeLengthMenu');
    const searchInput = document.getElementById('nativeSearchInput');
    const filterForm = document.getElementById('filterForm');

    let start = 0;
    let length = parseInt(lengthMenu ? lengthMenu.value : 50);
    let search = '';
    let orderColumn = 'kode_tiang';
    let orderDir = 'desc';
    let drawCount = 0;
    let isFetching = false;

    // Map database column names to index positions expected by controller
    const columnNames = [
        'checkbox',          // 0
        'no',                // 1
        'kode_tiang',        // 2
        'nomor_tiang',       // 3
        'id_up3',            // 4
        'id_ulp',            // 5
        'id_penyulang',      // 6
        'radius',            // 7
        'id_kategori_asset', // 8
        'status',            // 9
        'actions'            // 10
    ];

    async function fetchData() {
        if (isFetching) return;
        isFetching = true;

        // Reset bulk selection checks
        const checkAll = document.getElementById('check-all');
        if (checkAll) checkAll.checked = false;
        $('#bulk-action-bar').addClass('d-none').removeClass('d-flex');

        // Show loading state
        tableBody.innerHTML = `
            <tr>
                <td colspan="11" class="text-center py-5">
                    <div class="spinner-border text-primary" role="status" style="width: 2rem; height: 2rem; border-width: 0.15em;"></div>
                    <div class="mt-2 text-muted small">Memuat data...</div>
                </td>
            </tr>
        `;

        try {
            const params = new URLSearchParams();
            params.append('draw', ++drawCount);
            params.append('start', start);
            params.append('length', length);
            params.append('search[value]', search);

            // Populate columns config for server-side
            columnNames.forEach((name, idx) => {
                params.append(`columns[${idx}][data]`, name);
                params.append(`columns[${idx}][name]`, name);
                params.append(`columns[${idx}][searchable]`, (idx >= 2 && idx <= 9) ? 'true' : 'false');
                params.append(`columns[${idx}][orderable]`, (idx >= 2 && idx <= 9) ? 'true' : 'false');
            });

            // Set Order
            const orderIdx = columnNames.indexOf(orderColumn);
            if (orderIdx !== -1) {
                params.append('order[0][column]', orderIdx);
                params.append('order[0][dir]', orderDir);
            }

            // Append filter form data
            if (filterForm) {
                const formData = new FormData(filterForm);
                for (let [key, val] of formData.entries()) {
                    if (val) {
                        if (key.endsWith('[]')) {
                            params.append(key.replace('[]', ''), val);
                        } else {
                            params.append(key, val);
                        }
                    }
                }
            }

            const response = await fetch(`${ajaxUrl}?${params.toString()}`, {
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                }
            });

            if (!response.ok) {
                if (response.status === 401 || response.status === 403) {
                    throw new Error('Unauthorized');
                }
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const result = await response.json();

            // Render Rows
            if (!result.data || result.data.length === 0) {
                tableBody.innerHTML = `
                    <tr>
                        <td colspan="11" class="text-center py-5 text-muted">
                            <i class="bi bi-inbox fs-4 d-block mb-2"></i>
                            Tidak ada data tersedia
                        </td>
                    </tr>
                `;
                renderPagination(result.recordsTotal || 0, 0);
                renderInfo(result.recordsTotal || 0, 0);
            } else {
                let html = '';
                result.data.forEach(row => {
                    html += `
                        <tr>
                            <td class="text-center">${row.checkbox}</td>
                            <td>${row.no}</td>
                            <td>${row.kode}</td>
                            <td>${row.nomor}</td>
                            <td>${row.up3}</td>
                            <td>${row.ulp}</td>
                            <td>${row.penyulang}</td>
                            <td>${row.radius}</td>
                            <td>${row.kategori}</td>
                            <td>${row.status}</td>
                            <td class="text-end">${row.actions}</td>
                        </tr>
                    `;
                });
                tableBody.innerHTML = html;

                renderPagination(result.recordsTotal || 0, result.recordsFiltered || 0);
                renderInfo(result.recordsTotal || 0, result.recordsFiltered || 0);
            }
        } catch (error) {
            console.error('[TiangNative] Fetch error:', error);
            if (error.message === 'Unauthorized') {
                Swal.fire({
                    icon: 'warning',
                    title: 'Sesi Berakhir',
                    text: 'Silakan login kembali untuk melanjutkan.',
                    confirmButtonText: 'Login'
                }).then(() => {
                    window.location.reload();
                });
            } else {
                tableBody.innerHTML = `
                    <tr>
                        <td colspan="11" class="text-center py-5 text-danger">
                            <i class="bi bi-exclamation-triangle fs-4 d-block mb-2"></i>
                            Gagal memuat data: ${error.message}
                        </td>
                    </tr>
                `;
            }
        } finally {
            isFetching = false;
        }
    }

    function renderPagination(totalRecords, filteredRecords) {
        const paginationUl = document.getElementById('nativePagination');
        if (!paginationUl) return;

        paginationUl.innerHTML = '';
        const totalPages = Math.ceil(filteredRecords / length);
        console.log('[TiangNative] rendering pagination. totalRecords:', totalRecords, 'filteredRecords:', filteredRecords, 'length:', length, 'totalPages:', totalPages);
        if (isNaN(totalPages) || totalPages <= 0) return;

        const currentPage = Math.floor(start / length) + 1;
        const maxRange = 2; // Pages surrounding current

        // Prev Button
        const prevLi = document.createElement('li');
        prevLi.className = `page-item ${currentPage === 1 ? 'disabled' : ''}`;
        prevLi.innerHTML = `<a class="page-link rounded-start-pill px-3 shadow-none" href="#" data-page="${currentPage - 1}">Sebelumnya</a>`;
        paginationUl.appendChild(prevLi);

        for (let i = 1; i <= totalPages; i++) {
            if (i === 1 || i === totalPages || (i >= currentPage - maxRange && i <= currentPage + maxRange)) {
                const li = document.createElement('li');
                li.className = `page-item ${currentPage === i ? 'active' : ''}`;
                li.innerHTML = `<a class="page-link px-3 shadow-none" href="#" data-page="${i}">${i}</a>`;
                paginationUl.appendChild(li);
            } else if (i === currentPage - maxRange - 1 || i === currentPage + maxRange + 1) {
                const li = document.createElement('li');
                li.className = 'page-item disabled';
                li.innerHTML = '<span class="page-link px-2">...</span>';
                paginationUl.appendChild(li);
            }
        }

        // Next Button
        const nextLi = document.createElement('li');
        nextLi.className = `page-item ${currentPage === totalPages ? 'disabled' : ''}`;
        nextLi.innerHTML = `<a class="page-link rounded-end-pill px-3 shadow-none" href="#" data-page="${currentPage + 1}">Berikutnya</a>`;
        paginationUl.appendChild(nextLi);
    }

    function renderInfo(totalRecords, filteredRecords) {
        const infoSpan = document.getElementById('nativeTableInfo');
        if (!infoSpan) return;

        if (filteredRecords === 0) {
            infoSpan.innerHTML = '<span class="text-muted">Menampilkan 0 data</span>';
            return;
        }

        const startNum = start + 1;
        const endNum = Math.min(start + length, filteredRecords);

        let infoText = `Menampilkan <b class="text-dark">${startNum}-${endNum}</b> dari <b class="text-dark">${filteredRecords}</b>`;
        if (filteredRecords < totalRecords) {
            infoText += ` (disaring dari <b class="text-dark">${totalRecords}</b> data)`;
        }
        infoSpan.innerHTML = infoText;
    }

    // --- Debounce Helper ---
    let debounceTimeout;
    function debounce(func, delay = 300) {
        return function(...args) {
            clearTimeout(debounceTimeout);
            debounceTimeout = setTimeout(() => func.apply(this, args), delay);
        };
    }

    // --- Event Listeners ---

    // 1. Length Menu Change
    if (lengthMenu) {
        lengthMenu.addEventListener('change', function() {
            length = parseInt(this.value);
            start = 0;
            fetchData();
        });
    }

    // 2. Realtime Search Input (Debounced 300ms)
    if (searchInput) {
        searchInput.addEventListener('input', debounce(function() {
            search = this.value.trim();
            start = 0;
            fetchData();
        }, 300));
    }

    // 3. Sorting Headers Click
    const headers = table.querySelectorAll('.sortable-header');
    headers.forEach(header => {
        header.addEventListener('click', function() {
            const col = this.dataset.column;
            if (orderColumn === col) {
                orderDir = orderDir === 'asc' ? 'desc' : 'asc';
            } else {
                orderColumn = col;
                orderDir = 'asc';
            }

            // Update icons
            headers.forEach(h => {
                const icon = h.querySelector('.sort-icon');
                if (h === this) {
                    icon.className = `bi bi-arrow-${orderDir === 'asc' ? 'up' : 'down'} text-primary ms-1 small sort-icon`;
                } else {
                    icon.className = 'bi bi-arrow-down-up text-muted ms-1 small sort-icon';
                }
            });

            start = 0;
            fetchData();
        });
    });

    // 4. Pagination Click
    const paginationUl = document.getElementById('nativePagination');
    if (paginationUl) {
        paginationUl.addEventListener('click', function(e) {
            e.preventDefault();
            const link = e.target.closest('a');
            if (!link || link.parentNode.classList.contains('disabled') || link.parentNode.classList.contains('active')) {
                return;
            }

            const targetPage = parseInt(link.dataset.page);
            start = (targetPage - 1) * length;
            fetchData();
            
            // Scroll table to view smoothly
            table.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        });
    }

    // 5. Filter Form Events
    if (filterForm) {
        // Submit button triggers fetch
        filterForm.addEventListener('submit', function(e) {
            e.preventDefault();
            start = 0;
            fetchData();
        });


    }

    // 6. Global action page events integration
    // When a global CRUD delete or save is successful, reload this table
    $(document).on('crud-success', function() {
        fetchData();
    });

    // Initial Load
    fetchData();
}
